const cambiarPais = objeto => {
    return {
        type: 'cambiarPais',
        payload: objeto
    }
}

module.exports = {
    cambiarPais
}